// Class builders shared by the primitives and by route files that style a
// raw <input>/<Link> themselves. Kept out of primitives.tsx so that file
// exports only components (react-refresh/only-export-components).

export type ButtonVariant = 'primary' | 'secondary' | 'ghost' | 'danger';
export type ButtonSize = 'sm' | 'md' | 'lg';

const VARIANT: Record<ButtonVariant, string> = {
  primary: 'bg-canyon text-white font-semibold shadow-sm',
  secondary: 'border border-border bg-surface text-ink font-semibold',
  ghost: 'text-ink-2 hover:bg-surface-2 hover:text-ink',
  danger: 'bg-danger text-white font-semibold',
};
const SIZE: Record<ButtonSize, string> = {
  sm: 'px-md py-xs text-small gap-xs',
  md: 'px-lg py-sm text-body gap-sm',
  lg: 'px-xl py-md text-body gap-sm',
};

export function buttonClass(variant: ButtonVariant = 'primary', size: ButtonSize = 'md', extra = ''): string {
  return `inline-flex items-center justify-center whitespace-nowrap rounded-button ${VARIANT[variant]} ${SIZE[size]} disabled:cursor-not-allowed disabled:opacity-50 ${extra}`;
}

export const inputClass =
  'w-full rounded-input border border-border bg-surface px-md py-sm text-body text-ink placeholder:text-ink-3';
